import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DRenta210IngresoServicios } from '@dian-api/renta210-ingreso';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { ModalService, ModalType } from '../../modal/services/modal.service';
import { GeneralService } from '../../services/general.service';
import { DVersionRutaFormato } from '@dian/api-formulario';
import { DContextoMuisca } from '@dian/core';

@Component({
  selector: 'app-fraccion',
  templateUrl: './fraccion.component.html',
  styleUrls: ['./fraccion.component.css']
})
export class FraccionComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  versionesRuta: Array<DVersionRutaFormato> = [];
  habilitarFraccionAnio = false;
  aniosFraccion = [];
  fraccionAnio = false;
  enProceso : boolean;
  datosUsuario: DContextoMuisca;
  private tiempo:Date;

  constructor(private modalService: ModalService,
    private  router: Router,
    private fb: FormBuilder,
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private generalService: GeneralService,
    private configuracionFormulario: DFormularioConfiguracion,) { 
      this.buildForm();
      this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);
      this.generalService.datosRespuesta$.subscribe(res =>{
        this.datosUsuario = res;
      })
      this.tiempo = new Date();               
      let tiempoReal = new Date();                    
      setInterval(()=>{
          tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
          this.tiempo = new Date(tiempoReal);                    
      }, 1000);
    }

  ngOnInit() {
    this.showWelcome();
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }
  }

  buildForm(){
    this.form = this.fb.group({
      anio: new FormControl('', Validators.required),
    });
  }

  get formControls(){
    return this.form.controls;
  }

  showWelcome() {
    let infoMessage = '<p class="lh-18"><b>Recuerde: </b>Tras finalizar la liquidación de la sucesión del contribuyente, solo es necesario presentar la declaración de la fracción del año gravable siguiente ante la DIAN.</p>';
    const configBody = {
      title: 'Nueva fracción de año',
      message: '<p class="text-left">Antes de declarar renta por fracción de año, <b>asegúrese de haber presentado la declaración del año gravable inmediatamente anterior.</b> </p>',
      main_button: "Iniciar",
      secondary_button: "Salir",
      info_message: infoMessage, 
      main_action: "accept",
      text_align: "text-center",
      button_align: 'text-center',
      width: '350px',
      current_icon: './assets/img/png_v2/crear.png',
      onSecondaryAction: ()=>{this.router.navigate(['/', 'ingreso'])}
     }
     this.modalService.show(ModalType.SUCESS, configBody)
  }

  public obtenerVersionesRuta(ideFormato:number){
    let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    observableVersionesFormato.subscribe(
        res => { 
            this.versionesRuta = <Array<DVersionRutaFormato>>res;
            let anio = 0;
            for(let version of this.versionesRuta){
                if(version.indModoFraccion == "S" && version.indAccesoFormulario == "S"){//Se buscan si hay versiones fracción de año                     
                    if (anio < version.anioGravable) anio = version.anioGravable; 
                    this.verificarFraccionAnio(anio);//Verificar que la fracción sea mayor al año actual
                }
            }
            this.aniosFraccion.push(anio);//Se agrega el ultimo año que sea fracción o 0
            precargaProceso.close();
            this.enProceso = false;
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
            this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de las versiones del formato");
        }
    );    
  }

  private verificarFraccionAnio(anio:number) {
    let anioActual = (new Date()).getFullYear();   
    this.fraccionAnio = (Number(anio) >= anioActual) ? true :false;        
  }

  crearFraccion() {
    const anio = this.form.controls.anio.value;
    this.generalService.enviarFraccioAnio({anio: anio, enProceso: this.enProceso, fraccionAnio: this.fraccionAnio});
  }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/fraccion/fraccion.component.ts